export default "__VITE_ASSET__ad4bbd13__"